<div class="main-content1">

  <!-- SKELETON LOADING -->
  <div *ngIf="isLoading" class="skeleton-booking-detail">
    <!-- Gallery Skeleton -->
    <div class="skeleton-gallery">
      <div class="skeleton skeleton-big-img"></div>
      <div class="skeleton-small-grid">
        <div class="skeleton skeleton-small-img" *ngFor="let i of [1,2,3,4]"></div>
      </div>
    </div>

    <!-- Details Grid Skeleton -->
    <div class="skeleton-details-grid">
      <!-- Left Column -->
      <div class="skeleton-left">
        <div class="skeleton-specs-card">
          <div class="skeleton-header">
            <div class="skeleton-title-group">
              <div class="skeleton skeleton-title"></div>
              <div class="skeleton skeleton-brand"></div>
            </div>
            <div class="skeleton skeleton-rating"></div>
          </div>
          <div class="skeleton-divider"></div>
          <div class="skeleton-spec-group">
            <div class="skeleton skeleton-group-title"></div>
            <div class="skeleton-spec-grid">
              <div class="skeleton-spec-item" *ngFor="let i of [1,2,3,4,5,6]">
                <div class="skeleton skeleton-label"></div>
                <div class="skeleton skeleton-val"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="skeleton-right">
        <div class="skeleton-booking-card">
          <div class="skeleton skeleton-price"></div>
          <div class="skeleton skeleton-meta"></div>
          <div class="skeleton skeleton-toggle"></div>
          <div class="skeleton skeleton-date-box"></div>
          <div class="skeleton skeleton-meta" style="width: 100%; height: 80px;"></div>
          <div class="skeleton skeleton-btn"></div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="errorMessage" class="error-container">
    <p class="error">{{ errorMessage }}</p>
    <button class="back-btn" (click)="router.navigate(['/'])">Go Back</button>
  </div>

  <div *ngIf="equipmentData && categoryData" [hidden]="isLoading" class="booking-detail-wrapper">
    <!-- MAIN DETAILS -->
    <!-- ===== Gallery: 1 big image (left) + 2x2 small images (right) ===== -->
    <div class="image-grid-wrapper" *ngIf="equipmentData">
      <div class="image-grid">
        <!-- BIG IMAGE (left) -->
        <div class="big-slot">
          <img [src]="selectedImage || PREVIEW_IMAGE_URL" [alt]="equipmentData?.name || 'Equipment image'"
            (error)="handleBigImageError()" (click)="openImageViewer(0)" (load)="onImageLoad()" />
        </div>

        <!-- RIGHT: 2x2 small slots (always 4) -->
        <div class="small-grid">
          <ng-container *ngFor="let slot of smallImages; let i = index">
            <button class="small-slot" type="button" [attr.aria-label]="'Small image ' + (i + 1)">
              <!-- (click)="promoteSmallToBig(i)" -->
              <ng-container *ngIf="slot; else placeholder">
                <img [src]="slot" [alt]="
                    (equipmentData?.name || 'Equipment') + ' small ' + (i + 1)
                  " (error)="handleSmallImageError(i)" (click)="slot ? openImageViewer(i + 1) : null"
                  (load)="onImageLoad()" />
              </ng-container>

              <ng-template #placeholder>
                <div class="placeholder">
                  <!-- SVG fallback -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
                    <path fill="#979797"
                      d="M216 44H72a12 12 0 0 0-12 12v20H40a12 12 0 0 0-12 12v112a12 12 0 0 0 12 12h144a12 12 0 0 0 12-12v-20h20a12 12 0 0 0 12-12V56a12 12 0 0 0-12-12M68 56a4 4 0 0 1 4-4h144a4 4 0 0 1 4 4v72.4l-16.89-16.89a12 12 0 0 0-17 0l-22.83 22.83l-46.79-46.83a12 12 0 0 0-17 0L68 119Zm120 144a4 4 0 0 1-4 4H40a4 4 0 0 1-4-4V88a4 4 0 0 1 4-4h20v84a12 12 0 0 0 12 12h116Zm28-28H72a4 4 0 0 1-4-4v-37.66l37.17-37.17a4 4 0 0 1 5.66 0l49.66 49.66a4 4 0 0 0 5.65 0l25.66-25.66a4 4 0 0 1 5.66 0L220 139.71V168a4 4 0 0 1-4 4m-52-88a8 8 0 1 1 8 8a8 8 0 0 1-8-8" />
                  </svg>
                </div>
              </ng-template>
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- ===== LEFT COLUMN: title, subtitle, rating + specs ===== -->
    <div class="details-grid">
      <div class="left-col">
        <!-- Consolidated Vehicle Details Card -->
        <section class="specs-section">
          <div class="specs-card">
            <!-- Part 1: Vehicle Header Info -->
            <div class="card-header-main">
              <div class="header-left">
                <div class="title-row">
                  <h1 class="vehicle-title">{{ equipmentData.listingName || equipmentData.name }}</h1>
                  <span *ngIf="isDemo" class="demo-badge-detail">DEMO</span>
                </div>
                <p class="vehicle-brand">{{ equipmentData.brand || "-" }}</p>

                <div class="location-block" *ngIf="equipmentData.emirate">
                  {{ equipmentData.emirate }}
                </div>
              </div>

              <div class="header-right">
                <div class="rating-block" *ngIf="totalReviews > 0">
                  <div class="stars-list">
                    <mat-icon *ngFor="let s of [1, 2, 3, 4, 5]" [class.filled]="averageRating >= s" [class.half]="
                        averageRating < s && averageRating >= s - 0.5
                      ">
                      {{
                      averageRating >= s
                      ? "star"
                      : averageRating >= s - 0.5
                      ? "star_half"
                      : "star_outline"
                      }}
                    </mat-icon>
                  </div>
                  <div class="rating-info">
                    <span class="rating-val">{{ averageRating }}</span>
                    <span class="reviews-link-text" (click)="ux.openSnackBar('Reviews coming soon', 'OK')">
                      ({{ totalReviews }} reviews)
                    </span>
                  </div>
                </div>

                <!-- ADDED BELOW RATINGS -->
                <button class="share-btn" matTooltip="Share booking link" (click)="shareEquipment()"
                  aria-label="Share booking link">
                  <mat-icon>share</mat-icon>
                  <span>Share</span>
                </button>
              </div>
            </div>

            <div class="card-divider"></div>

            <!-- Part 2: Detailed Vehicle Info Sections -->
            <div class="detailed-specs-wrapper">
              <!-- Section 1: Vehicle Details -->
              <div class="specs-group">
                <h3 class="group-title">Vehicle Details</h3>
                <div class="spec-grid">
                  <div class="spec-item">
                    <span class="spec-label">Category</span>
                    <span class="spec-value">{{
                      categoryData?.name || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Model</span>
                    <span class="spec-value">{{
                      equipmentData.model || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Name</span>
                    <span class="spec-value">{{
                      equipmentData.listingName || equipmentData.name || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Brand</span>
                    <span class="spec-value">{{
                      equipmentData.brand || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Year of manufacture</span>
                    <span class="spec-value">{{
                      equipmentData.year_of_manufacture || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Country of origin</span>
                    <span class="spec-value">{{
                      equipmentData.country_of_origin || "—"
                      }}</span>
                  </div>
                </div>
              </div>

              <div class="card-divider"></div>

              <!-- Section 3: Vehicle Spec -->
              <div class="specs-group">
                <h3 class="group-title">Vehicle Spec</h3>
                <div class="spec-grid">
                  <div class="spec-item">
                    <span class="spec-label">Fuel type</span>
                    <span class="spec-value">{{
                      equipmentData.fuel_type || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Engine output</span>
                    <span class="spec-value">{{
                      equipmentData.engine_output || "—"
                      }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">Additional feature</span>
                    <span class="spec-value">{{
                      equipmentData.additional_features ||
                      equipmentData.features ||
                      "—"
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- ===== RIGHT COLUMN: booking card (sticky) ===== -->
      <aside class="right-col">
        <div class="booking-card" role="region" aria-label="Booking card">
          <!-- PRICE TOP -->
          <div class="price-top" *ngIf="equipmentData.hasRentalRates !== false">
            <div class="amount-line">
              <div class="currency">AED</div>
              <div class="amount">
                {{
                selectedPriceType === "daily"
                ? equipmentData.dailyRate
                : selectedPriceType === "weekly"
                ? equipmentData.weeklyRate
                : selectedPriceType === "monthly"
                ? equipmentData.monthlyRate
                : selectedPriceType === "per_trip"
                ? equipmentData.tripRate
                : equipmentData.perCubicMetreRate
                }}
              </div>
              <div class="period">
                /
                {{
                selectedPriceType === "daily"
                ? "day"
                : selectedPriceType === "weekly"
                ? "week"
                : selectedPriceType === "monthly"
                ? "month"
                : selectedPriceType === "per_trip"
                ? "trip"
                : "cbm"
                }}
              </div>
            </div>
          </div>

          <!-- META -->
          <div class="meta-row" *ngIf="equipmentData.hasRentalRates !== false">
            <div class="small">
              With Driver :
              {{ isIncluded("Driver") ? "Yes" : "No" }}
            </div>
            <div class="small">
              With Fuel : {{ isIncluded("Fuel") ? "Yes" : "No" }}
            </div>
            <div class="small">
              With Salik : {{ isIncluded("Salik") ? "Yes" : "No" }}
            </div>
          </div>

          <!-- PRICE TOGGLE -->
          <div class="period-toggle" role="tablist" *ngIf="equipmentData.hasRentalRates !== false">
            <label class="toggle-pill"
              *ngIf="equipmentData.hasTripRate !== undefined ? equipmentData.hasTripRate : (equipmentData.tripRate > 0)">
              <input type="radio" name="priceType" value="per_trip" [(ngModel)]="selectedPriceType"
                (ngModelChange)="onPriceTypeChange()" />
              <span>Per trip</span>
            </label>
            <label class="toggle-pill"
              *ngIf="equipmentData.hasDailyRate !== undefined ? equipmentData.hasDailyRate : (equipmentData.dailyRate > 0)">
              <input type="radio" name="priceType" value="daily" [(ngModel)]="selectedPriceType"
                (ngModelChange)="onPriceTypeChange()" />
              <span>Daily</span>
            </label>

            <label class="toggle-pill"
              *ngIf="equipmentData.hasWeeklyRate !== undefined ? equipmentData.hasWeeklyRate : (equipmentData.weeklyRate > 0)">
              <input type="radio" name="priceType" value="weekly" [(ngModel)]="selectedPriceType"
                (ngModelChange)="onPriceTypeChange()" />
              <span>Weekly</span>
            </label>

            <label class="toggle-pill"
              *ngIf="equipmentData.hasMonthlyRate !== undefined ? equipmentData.hasMonthlyRate : (equipmentData.monthlyRate > 0)">
              <input type="radio" name="priceType" value="monthly" [(ngModel)]="selectedPriceType"
                (ngModelChange)="onPriceTypeChange()" />
              <span>Monthly</span>
            </label>

            <label class="toggle-pill"
              *ngIf="equipmentData.hasPerCubicMetreRate !== undefined ? equipmentData.hasPerCubicMetreRate : (equipmentData.perCubicMetreRate > 0)">
              <input type="radio" name="priceType" value="cbm" [(ngModel)]="selectedPriceType"
                (ngModelChange)="onPriceTypeChange()" />
              <span>Cubic Metre</span>
            </label>
          </div>

          <!-- DATE + EMIRATE CARD -->
          <div class="date-card">
            <div class="date-grid">
              <!-- FROM -->
              <!-- FROM -->
              <div class="date-cell">
                <div class="label">
                  {{ selectedPriceType === "per_trip" ? "Date" : "From" }}
                  <span style="color: red">*</span>
                </div>

                <div class="value" (click)="openFromCalendar($event)">
                  {{ selectedStart || "Start date" }}
                </div>

                <div class="calendar-dropdown" *ngIf="showCalendarFrom" (click)="$event.stopPropagation()">
                  <div class="calendar-header">
                    <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                    <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                    <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                  </div>

                  <div class="calendar-weekdays">
                    <span *ngFor="let d of weekdays">{{ d }}</span>
                  </div>

                  <div class="calendar-grid">
                    <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                      [class.is-today]="day.isToday" [class.is-past]="day.isPast" [class.booked]="day.isBooked"
                      [class.is-start]="day.isStart" [class.is-end]="day.isEnd" (click)="
                        !day.isPast && !day.isBooked && selectStartDay(day)
                      ">
                      {{ day.date }}
                    </span>
                  </div>
                </div>
                <!-- <span class="divider"></span> -->
              </div>

              <!-- TILL -->

              <!-- TILL -->
              <!-- TILL -->
              <!-- TILL -->
              <div class="date-cell till-cell">
                <div class="label">
                  {{
                  selectedPriceType === "per_trip"
                  ? "Number of trips"
                  : "Till"
                  }}
                  <span style="color: red">*</span>
                </div>

                <!-- CLICKABLE VALUE -->
                <div class="value" *ngIf="selectedPriceType !== 'per_trip'; else quantityInput"
                  (click)="openToCalendar($event)">
                  {{ selectedEnd || "End date" }}
                </div>

                <ng-template #quantityInput>
                  <input type="number" class="value triprate-input" [(ngModel)]="numberOfTrips" min="1"
                    (click)="$event.stopPropagation()" />
                </ng-template>

                <!-- CALENDAR DROPDOWN FOR TILL -->
                <div class="calendar-dropdown" *ngIf="showCalendarTo" (click)="$event.stopPropagation()">
                  <div class="calendar-header">
                    <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                    <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                    <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                  </div>

                  <div class="calendar-weekdays">
                    <span *ngFor="let d of weekdays">{{ d }}</span>
                  </div>

                  <div class="calendar-grid">
                    <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                      [class.is-today]="day.isToday" [class.is-past]="day.isPast" [class.booked]="day.isBooked"
                      [class.is-start]="day.isStart" [class.is-end]="day.isEnd" (click)="
                        !day.isPast && !day.isBooked && selectEndDay(day)
                      ">
                      {{ day.date }}
                    </span>
                  </div>
                </div>

                <!-- PLUS / MINUS -->
                <div class="pm-wrapper" *ngIf="selectedPriceType !== 'per_trip'">
                  <div class="pm-wrapper">
                    <!-- PLUS -->
                    <button class="pm plus" (click)="onPlusClick()">
                      <span class="tooltip">{{ plusTooltip }}</span>
                    </button>

                    <!-- MINUS -->
                    <button class="pm minus" (click)="onMinusClick()" [disabled]="!canMinus">
                      <span class="tooltip">{{ minusTooltip }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- EMIRATE -->
            <div class="emirate-row">
              <div class="label">Emirate</div>
              <div class="value">{{ equipmentData.emirate || "—" }}</div>
            </div>

            <!-- ADDRESS -->
            <div class="emirate-row1">
              <div class="label">
                Location <span style="color: red">*</span>
              </div>
              <textarea class="value triprate-input" [(ngModel)]="bookingAddress" placeholder="e.g. Jebel Ali Site A"
                rows="1"></textarea>
            </div>
          </div>

          <!-- HELPER TEXTS -->
          <div class="helper-text" *ngIf="equipmentData.hasRentalRates !== false">
            <!-- DAILY -->
            <h4 class="muted-heading" *ngIf="selectedPriceType === 'daily'">
              Daily Date Range
            </h4>
            <p class="muted" *ngIf="selectedPriceType === 'daily'">
              Select specific “From” and “Till” dates OR <br />
              Using “<span class="muted-text">+</span>” or “<span class="muted-text">-</span>” increases or decreases by
              1 day.
            </p>

            <!-- WEEKLY -->
            <h4 class="muted-heading" *ngIf="selectedPriceType === 'weekly'">
              Weekly Date Range
            </h4>

            <p class="muted" *ngIf="selectedPriceType === 'weekly'">
              “Till” date is automatically set to 7 days from the “From” date.
              Using “<span class="muted-text">+</span>” or “<span class="muted-text">-</span>” increases or decreases by
              7 days only.
            </p>

            <!-- MONTHLY / CBM -->
            <h4 class="muted-heading" *ngIf="selectedPriceType === 'monthly' || selectedPriceType === 'cbm'">
              {{ selectedPriceType === 'cbm' ? 'Cubic Metre' : 'Monthly' }} Date Range
            </h4>

            <p class="muted" *ngIf="selectedPriceType === 'monthly' || selectedPriceType === 'cbm'">
              “Till” date is automatically set to 30 days from the “From” date.
              Using “<span class="muted-text">+</span>” or “<span class="muted-text">-</span>” increases or decreases by
              30 days only.
            </p>
          </div>

          <!-- SUMMARY -->
          <div class="price-summary" *ngIf="equipmentData.hasRentalRates !== false">
            <div class="row1">
              <div class="left">
                <span class="aed">AED</span>
                {{
                selectedPriceType === "daily"
                ? equipmentData.dailyRate + " x " + daysCount + " day"
                : selectedPriceType === "weekly"
                ? equipmentData.weeklyRate + " x " + weeksCount + " week"
                : selectedPriceType === "monthly"
                ? equipmentData.monthlyRate +
                " x " +
                monthsCount +
                " month"
                : selectedPriceType === "per_trip"
                ? equipmentData.tripRate +
                " x " +
                numberOfTrips +
                " trip"
                : equipmentData.perCubicMetreRate +
                " x " +
                volumeCbm +
                " cbm"
                }}
              </div>

              <div class="right">
                <span class="aed">AED</span>
                {{
                computedTotal
                ? computedTotal
                : selectedPriceType === "daily"
                ? equipmentData.dailyRate
                : selectedPriceType === "weekly"
                ? equipmentData.weeklyRate
                : selectedPriceType === "monthly"
                ? equipmentData.monthlyRate || 0
                : selectedPriceType === "per_trip"
                ? equipmentData.tripRate
                : equipmentData.perCubicMetreRate || 0
                }}
              </div>
            </div>

            <hr class="summary-divider" />

            <!-- <div class="total">
        <div class="label">Total</div>
        <div class="big">
          {{
            computedTotal
              ?'AED' + computedTotal
              : 'AED' +
                (selectedPriceType === 'daily'
                  ? equipmentData.dailyRate
                  : selectedPriceType === 'weekly'
                  ? equipmentData.weeklyRate
                  : equipmentData.monthlyRate || 0)
          }}
        </div>
      </div> -->
            <div class="total">
              <div class="label">Total</div>
              <div class="big">
                <span class="aed">AED</span>
                {{
                computedTotal
                ? computedTotal
                : selectedPriceType === "daily"
                ? equipmentData.dailyRate
                : selectedPriceType === "weekly"
                ? equipmentData.weeklyRate
                : selectedPriceType === "monthly"
                ? equipmentData.monthlyRate || 0
                : selectedPriceType === "per_trip"
                ? equipmentData.tripRate
                : equipmentData.perCubicMetreRate || 0
                }}
              </div>
            </div>
          </div>
          <!-- AVAILABILITY ERROR -->
          <div *ngIf="isSelectionUnavailable" style="
              color: #dc2626;
              font-size: 13px;
              margin-top: 10px;
              font-weight: 500;
            ">
            Selected dates are not available.
          </div>

          <!-- BUTTON -->
          <button class="send-enquiry" (click)="onProceed()" [disabled]="
              !startDate ||
              (!endDate && selectedPriceType !== 'per_trip') ||
              !bookingAddress ||
              !bookingAddress.trim() ||
              isSelectionUnavailable
            ">
            {{ isSelectionUnavailable ? "Dates Unavailable" : (editingItemId ? "Update Cart" : "Add to Cart") }}
          </button>
        </div>

        <!-- <div class="report-link">
          <mat-icon>flag_outline</mat-icon>
          <a (click)="reportListing()">Report this listing</a>
        </div> -->
      </aside>
    </div>
    <!-- ===== "Please note the following" + Reviews section ===== -->
    <section class="notes-and-reviews">
      <!-- Divider -->
      <hr class="section-divider" />

      <!-- Info cards -->
      <div class="notes-cards">
        <h3>Please note the following</h3>

        <div class="cards-row">
          <!-- Enquiry -->
          <div class="info-card">
            <div class="icon-wrap" aria-hidden="true">
              <!-- small clipboard/message SVG icon -->
              <img src="assets/icons/enquiry.png" alt="" srcset="" />
            </div>
            <div>
              <h4>Enquiry</h4>
              <p>
                Sending Enquiry does not confirm a booking. Once an enquiry is
                accepted by the vendor, customer will receive a notification
                along with the vendor's contact details.
              </p>
            </div>
          </div>

          <!-- Payment -->
          <div class="info-card">
            <div class="icon-wrap" aria-hidden="true">
              <!-- card SVG -->
              <img src="assets/icons/payment.png" alt="" />
            </div>
            <div>
              <h4>Payment</h4>
              <p>
                Aluguloo does not collect payments from customers. All price
                negotiations and payments should be managed directly with the
                vendor.
              </p>
            </div>
          </div>

          <!-- Cancellation -->
          <div class="info-card">
            <div class="icon-wrap" aria-hidden="true">
              <!-- cancel/clock SVG -->
              <img src="assets/icons/cancellation .png" alt="" />
            </div>
            <div>
              <h4>Cancellation</h4>
              <p>
                Customers may cancel pending enquiries at any time. However
                cancellations of confirmed bookings should only be made with
                valid and genuine reasons.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="section-divider" />

      <!-- Reviews header -->
      <div class="reviews-header">
        <h3>{{ reviews.length }} reviews</h3>
      </div>

      <!-- Reviews grid -->
      <!-- <div class="reviews-grid">
    <ng-container *ngFor="let r of dummyReviews; let i = index">
      <article class="review-card" role="article" >
      
        <div class="review-meta">
          <div class="avatar" [attr.aria-hidden]="true">{{ r.name.charAt(0) }}</div>
          <div class="who">
            <div class="name">{{ r.name }}</div>
            <div class="date">{{ r.date }}</div>
          </div>
        </div>

        <div class="review-body">
          <p class="comment">{{ r.comment }}</p>
          <button class="show-more" (click)="showMore(r)">Show more ›</button>
          
        </div>
      </article>
    </ng-container>
  </div> -->
      <div class="reviews-grid">
        <ng-container *ngFor="
            let r of showAllReviews ? reviews : reviews.slice(0, 4);
            let i = index
          ">
          <article class="review-card">
            <div class="review-meta">
              <!-- Avatar -->
              <div class="avatar">
                <ng-container *ngIf="r.profilePic; else letterAvatar">
                  <img [src]="r.profilePic" alt="Profile" />
                </ng-container>

                <ng-template #letterAvatar>
                  {{ r.userName.charAt(0).toUpperCase() }}
                </ng-template>
              </div>
              <div class="who">
                <div class="name">{{ r.userName }}</div>
                <div class="date">{{ r.date }}</div>
              </div>
            </div>

            <!-- ⭐ Rating Stars -->
            <!-- <div class="rating-stars">
        <mat-icon *ngFor="let s of [1,2,3,4,5]"
          [ngClass]="{filled: r.rating >= s}">
          {{ r.rating >= s ? 'star' : 'star_border' }}
        </mat-icon>
      </div> -->

            <div class="review-body">
              <p class="comment" [class.collapsed]="!r.expanded" [id]="'review-text-' + i">
                {{ r.finalReview }}
              </p>

              <button *ngIf="r.needsMore" class="show-more" (click)="r.expanded = !r.expanded">
                {{ r.expanded ? "Show less ‹" : "Show more ›" }}
              </button>
              <!-- QUESTIONS SECTION -->
              <div class="question-row" *ngIf="r.questions?.length">
                <div class="question-item" *ngFor="let q of r.questions">
                  {{ q.question }}: {{ q.answer }}
                </div>
              </div>
            </div>
          </article>
        </ng-container>
      </div>
      <!-- Show all reviews button -->
      <div class="show-all-row">
        <button class="show-all" *ngIf="!showAllReviews && totalReviews > 4" (click)="showAllReviews = true">
          Show all {{ totalReviews }} reviews
        </button>
      </div>
      <!-- Divider -->
      <hr class="section-divider" />
    </section>

    <!-- RECOMMENDED PRODUCTS -->
    <div class="recommended-section" *ngIf="subcategoryData.length">
      <div class="recommended-header">
        <h2>
          Recommended Equipments
          <span *ngIf="equipmentData?.emirate">in {{ equipmentData.emirate }}</span>
        </h2>
        <span class="view-all" (click)="viewAll()">View All</span>
      </div>

      <div class="recommended-grid">
        <div class="card" *ngFor="let product of subcategoryData" [routerLink]="['/booking-detail', product.id]">
          <div class="image-box">
            <img [src]="product.images?.[0] || 'assets/default-equipment.jpg'" />
          </div>

          <div class="details">
            <div class="rating">
              ⭐ {{ product.avgRating || 0 }}
              <small>({{ product.totalReviews || 0 }})</small>
            </div>

            <h4>{{ product.name }}</h4>

            <p>{{ product.brand }}</p>
            <p>Year of Mfr : {{ product.year_of_manufacture }}</p>

            <p class="price">
              <strong>AED {{ product.dailyRate }}</strong> day
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- </div> -->
  </div>
  <!-- SERVICE CARDS -->
  <!-- <section class="service-cta-section">
    <div class="service-cta-grid">
      <div class="service-card">
        <img src="assets/landingpage/1.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Is it time to get your vehicle serviced?</h2>
          <button>Book Garage</button>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/landingpage/2.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Is your vehicle due for passing test?</h2>
          <button>Book Services</button>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/landingpage/3.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Did your vehicle face a sudden breakdown?</h2>
          <button>Book Tow Truck</button>
        </div>
      </div>
    </div>
  </section> -->

  <!-- BECOME VENDOR -->
  <section class="become_vendor">
    <h1>Want to become a vendor on Aluguloo?</h1>
    <button class="become_btn" (click)="openServiceOfferDialog()">Let's Connect</button>
  </section>
</div>